import { createContext, useContext, useEffect, useRef, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);
export const puedeEco = (u) => u?.role === "admin" || !!u?.ve_economico;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const save = (data) => {
    localStorage.setItem("token", data.token);
    setUser(data.user);
  };
  const login = async (email, password) => save((await api.post("/auth/login", { email, password })).data);
  const loginGoogle = async (session_id) => save((await api.post("/auth/google", { session_id })).data);
  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
  };
  return <AuthContext.Provider value={{ user, setUser, login, loginGoogle, logout }}>{children}</AuthContext.Provider>;
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const googleLogin = () => {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const AuthCallback = () => {
  const { loginGoogle, setUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) {
      return;
    }
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    loginGoogle(sid)
      .then(() => navigate("/", { replace: true }))
      .catch((e) => {
        sessionStorage.setItem("login_error", errMsg(e));
        setUser(false);
        navigate("/login", { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-8 text-sm text-slate-400">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
